module.exports = __webpack_public_path__ + "e0106718/img/search-filter-icon.c4751a52.svg";